export default __webpack_public_path__ + "static/media/Icon6_On.b49cba61.png";